// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Counter_componentWrapper__C4KHs","input":"Counter_input__k8b2i","button":"Counter_button__OSWXq"};